<div class="dropdown">
    <button type="button" id="payment-history-search-filter-dropdown" class="btn btn-ms-secondary dropdown-toggle"
        data-bs-auto-close="outside" data-bs-toggle="dropdown" aria-expanded="false">
        <fa-duotone-icon icon="filter" secondaryOpacity="0.6" class="fs-6 d-none d-sm-inline" />
        Filter
        @if (filterCount > 0) {
        <span
            class="position-absolute top-0 start-0 translate-middle badge border rounded-circle filter-count">{{filterCount}}</span>
        }
    </button>

    <div ms-parent-focus [alwaysFocusOnRemoval]="true" class="dropdown-menu" (keyup.control.enter)="onApply()">

        <div class="fs-5 fw-bold px-3 py-2">Filter Options</div>

        <div class="separator border-gray-200"></div>

        <div class="mb-2 px-3 py-2 mw-100">
            <label class="form-label fw-semibold">Property Title:</label>
            <div class="input-group">
                <input type="text" class="form-control form-control-solid" placeholder="Enter property title"
                    [(ngModel)]="propertyTitleInput" (keyup.enter)="addPropertyTitle()" />
                <button class="btn btn-primary px-3" type="button" (click)="addPropertyTitle()">
                    <fa-duotone-icon icon="plus" secondaryOpacity="0.9" />
                </button>
            </div>
            <div class="d-flex flex-wrap w-100">
                @if (filter().propertyTitles && filter().propertyTitles!.length > 0) {
                <div class="mt-2">
                    @for (title of filter().propertyTitles; track $index) {
                    <button class="tag-filter btn btn-primary" type="button" (click)="removePropertyTitle($index)">{{title}}
                        <fa-duotone-icon icon="minus" secondaryOpacity="0.9" />
                    </button>
                    }
                </div>
                }
            </div>
        </div>

        <div class="mb-2 px-3 py-2 mw-100">
            <label class="form-label fw-semibold">Address Line 1:</label>
            <div class="input-group">
                <input type="text" class="form-control form-control-solid" placeholder="Enter address"
                    [(ngModel)]="addressInput" (keyup.enter)="addAddress()" />
                <button class="btn btn-primary px-3" type="button" (click)="addAddress()">
                    <fa-duotone-icon icon="plus" secondaryOpacity="0.9" />
                </button>
            </div>
            <div class="d-flex flex-wrap w-100">
                @if (filter().primaryAddresses && filter().primaryAddresses!.length > 0) {
                <div class="mt-2">
                    @for (address of filter().primaryAddresses; track $index) {
                    <button class="tag-filter btn btn-primary" type="button" (click)="removeAddress($index)">{{address}}
                        <fa-duotone-icon icon="minus" secondaryOpacity="0.9" />
                    </button>
                    }
                </div>
                }
            </div>
        </div>

        <div class="mb-2 px-3 py-2 mw-100">
            <label class="form-label fw-semibold">Lot #:</label>
            <div class="input-group">
                <input type="text" class="form-control form-control-solid" placeholder="Enter lot number"
                    [(ngModel)]="lotNumberInput" (keyup.enter)="addLotNumber()" />
                <button class="btn btn-primary px-3" type="button" (click)="addLotNumber()">
                    <fa-duotone-icon icon="plus" secondaryOpacity="0.9" />
                </button>
            </div>
            <div class="d-flex flex-wrap w-100">
                @if (filter().lotNumbers && filter().lotNumbers!.length > 0) {
                <div class="mt-2">
                    @for (lotNumber of filter().lotNumbers; track $index) {
                    <button class="tag-filter btn btn-primary" type="button" (click)="removeLotNumber($index)">{{lotNumber}}
                        <fa-duotone-icon icon="minus" secondaryOpacity="0.9" />
                    </button>
                    }
                </div>
                }
            </div>
        </div>

        <div class="separator border-gray-200 my-2"></div>

        <div class="mb-2 px-3 py-2 mw-100">
            <label class="form-label fw-semibold">Due Date:</label>
            <div class="row">
                <div class="col-6">
                    <input type="date" class="form-control form-control-solid"
                        [(ngModel)]="filter().minimumDueDate" />
                </div>
                <div class="col-6">
                    <input type="date" class="form-control form-control-solid"
                        [(ngModel)]="filter().maximumDueDate" />
                </div>
            </div>
        </div>

        <div class="mb-2 px-3 py-2 mw-100">
            <label class="form-label fw-semibold">Date Paid:</label>
            <div class="row">
                <div class="col-6">
                    <input type="date" class="form-control form-control-solid"
                        [(ngModel)]="filter().minimumPaidDate" />
                </div>
                <div class="col-6">
                    <input type="date" class="form-control form-control-solid"
                        [(ngModel)]="filter().maximumPaidDate" />
                </div>
            </div>
        </div>

        <div class="separator border-gray-200 my-2"></div>

        <div class="mb-2 px-3 py-2">
            <label class="form-label fw-semibold">Status:</label>
            <ms-multi-select placeholder="Select Status" [options]="selectStatusOptions"
                [(selectedOptions)]="selectedStatuses" (selectionChange)="onStatusChange($event)" />
        </div>

        <div class="separator border-gray-200 my-2"></div>

        <div class="mb-2 px-3 py-2 mw-100">
            <label class="form-label fw-semibold">Amount:</label>
            <div class="row">
                <div class="col-6">
                    <input type="number" class="form-control form-control-solid" placeholder="Min"
                        [(ngModel)]="minimumAmountDisplay" />
                </div>
                <div class="col-6">
                    <input type="number" class="form-control form-control-solid" placeholder="Max"
                        [(ngModel)]="maximumAmountDisplay" />
                </div>
            </div>
        </div>

        <div class="mb-2 px-3 py-2 mw-100">
            <label class="form-label fw-semibold">Fees:</label>
            <div class="row">
                <div class="col-6">
                    <input type="number" class="form-control form-control-solid" placeholder="Min"
                        [(ngModel)]="minimumFeesDisplay" />
                </div>
                <div class="col-6">
                    <input type="number" class="form-control form-control-solid" placeholder="Max"
                        [(ngModel)]="maximumFeesDisplay" />
                </div>
            </div>
        </div>

        <div class="separator border-gray-200 my-2"></div>

        <div class="mb-2 px-3 py-2 mw-100">
            <label class="form-label fw-semibold">Payment Source:</label>
            <select class="form-select form-control-solid" [(ngModel)]="manualOnlyToggle">
                <option value="all">All payments</option>
                <option value="stripe">Stripe payments only</option>
                <option value="manual">Manual payments only</option>
            </select>
        </div>

        <div class="d-flex justify-content-end px-3 py-2">
            <button type="button" class="btn btn-ms-secondary reset-filter-button me-2 px-6"
                (click)="onReset()">Reset</button>
            <button type="button" class="btn btn-primary px-6" (click)="onApply()">Apply</button>
        </div>

    </div>
</div>
